import React from "react";
import { DestinationColor } from "@silversea-ssc/ui-components-react";
import { titleCase } from "src/utils/strings";

import LinkPictureCard, {
  LinkPictureCardProps
} from "components/Card/LinkPictureCard";

export interface DestinationCardProps {
  title: string;
  image?: LinkPictureCardProps["image"];
  destinationId?: number;
  url?: string;
}

const DestinationCard: React.FC<DestinationCardProps> = ({
  title,
  image,
  destinationId,
  url
}) => {
  const titleCaseTitle = titleCase(title);
  return (
    <DestinationColor destinationId={destinationId}>
      <LinkPictureCard
        borderColor="destination"
        key={destinationId}
        url={url}
        title={titleCaseTitle}
        image={image}
        // dataContentPiece={trackingName || destinationId}
      />
    </DestinationColor>
  );
};

export default DestinationCard;
